import apiInstance, { apiInstance1, apiInstance2 } from "../../api-config/axios-instance";

export function UploadOrderFile(payload) {
  const response = apiInstance2.post("/profleImageUpload", payload);
  return response;
}
export function submitWireFile(payload) {
  const response = apiInstance.post("order/addwirereceipt", payload);
  return response;
}
